'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EntityViewRoutes;

var _entityViewsTpl = require('./entity-views.tpl.html');

var _entityViewsTpl2 = _interopRequireDefault(_entityViewsTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
function EntityViewRoutes($stateProvider, types) {
    $stateProvider.state('home.entityViews', {
        url: '/entityViews',
        params: { 'topIndex': 0 },
        module: 'private',
        auth: ['TENANT_ADMIN', 'CUSTOMER_USER'],
        views: {
            "content@home": {
                templateUrl: _entityViewsTpl2.default,
                controller: 'EntityViewController',
                controllerAs: 'vm'
            }
        },
        data: {
            entityViewsType: 'tenant',
            searchEnabled: true,
            searchByEntitySubtype: true,
            searchEntityType: types.entityType.entityView,
            pageTitle: 'entity-view.entity-views'
        },
        ncyBreadcrumb: {
            label: '{"icon": "view_quilt", "label": "entity-view.entity-views"}'
        }
    }).state('home.customers.entityViews', {
        url: '/:customerId/entityViews',
        params: { 'topIndex': 0 },
        module: 'private',
        auth: ['TENANT_ADMIN'],
        views: {
            "content@home": {
                templateUrl: _entityViewsTpl2.default,
                controllerAs: 'vm',
                controller: 'EntityViewController'
            }
        },
        data: {
            entityViewsType: 'customer',
            searchEnabled: true,
            searchByEntitySubtype: true,
            searchEntityType: types.entityType.entityView,
            pageTitle: 'customer.entity-views'
        },
        ncyBreadcrumb: {
            label: '{"icon": "view_quilt", "label": "{{ vm.customerEntityViewsTitle }}", "translate": "false"}'
        }
    });
} /*
   * Copyright © 2016-2018 The Thingsboard Authors
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
/* eslint-disable import/no-unresolved, import/default */


// WEBPACK FOOTER //
// ./src/app/entity-view/entity-view.routes.js